export default "/images/5eed5f2efde8405cd5215e67ba7e5a36.avif";